import { isSupabaseConfigured } from "@/lib/db";

/**
 * Renders a warning banner when Supabase env is not configured, so the app
 * stays usable (rule engine / merge are pure and DB-free) instead of crashing.
 * Env guard for the .env-less build/run path (task #4).
 */
export function ConfigBanner(): JSX.Element | null {
  if (isSupabaseConfigured()) return null;
  return (
    <div className="config-banner" role="alert">
      Supabase 환경변수(<code>VITE_SUPABASE_URL</code>,{" "}
      <code>VITE_SUPABASE_ANON_KEY</code>)가 설정되지 않았습니다. 마스터·딜
      데이터는 비활성 상태입니다. 룰 게이트·서류 머지는 정상 동작합니다.{" "}
      <code>.env.example</code>를 <code>.env</code>로 복사해 채우세요.
    </div>
  );
}
